<template>
  <b-card>
    <validation-observer ref="formRef">
      <b-form @submit.prevent="validateAndSubmit">
        <b-row>

          <!-- Name -->
          <b-col md="6">
            <b-form-group :label="$t('label.Name')" :label-for="$t('label.name')" description="">
              <validation-provider :name="$t('label.Name')" rules="required" v-slot="{ errors }">
                <b-form-input
                  id="name"
                  v-model="form.name"
                  trim
                  :placeholder="$t('placeholder.Technical_Assistant')"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Code -->
          <b-col md="6">
            <b-form-group :label="$t('label.code')" :label-for="$t('label.code')" description="">
              <validation-provider :name="$t('label.code')" rules="required" v-slot="{ errors }">
                <b-form-input
                  id="code"
                  v-model="form.code"
                  trim
                  :placeholder="$t('placeholder.ta01')"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Description -->
        <b-form-group :label="$t('label.role_desc')" :label-for="$t('label.role_desc')">
          <b-form-textarea
            id="description"
            v-model="form.description"
            :placeholder="$t('placeholder.role_desc')"
            rows="3"
          ></b-form-textarea>
          <small class="text-muted">{{ $t('message.role_desc') }}</small>
        </b-form-group>

        <!-- Parent roles -->
        <b-form-group :label="$t('label.parentRoles')" :label-for="'parentRoles'">
          <v-select
            id="parentRoles"
            v-model="form.parentRoles"
            :reduce="(roles) => roles.value"
            :multiple="true"
            label="title"
            :options="rolesOptions"
            :placeholder="$t('placeholder.parentRoles')"
          ></v-select>
        </b-form-group>

        <b-button type="submit" variant="primary" :disabled="isSubmitting">
          {{ $t('message.submit') }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api"
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import i18n from '@/libs/i18n'
import vSelect from 'vue-select'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'
import store from '@/store'
  
export default {
  name: 'FormTraditional',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect
  },

  props: ["data", "isSubmitting"],
  
  setup(props, { emit }) {
    // console.log(props)
    // const form = ref({
    //   name: props.data?.name || "",
    //   code: props.data?.code || "",
    //   description: props.data?.description || "",
    //   parentRoles: props.data?.parentRoles || []
    // })
    const form = ref({
      name: "",
      code: "",
      description: "",
      parentRoles: []
    })

    const formRef = ref(null)
    const rolesOptions = ref([])
    const { getItems } = useLambda()
    const userData = store.state?.userStore?.userData;
    const clientId = userData.role !== "admin" ? userData.client.$oid : null

    watch(
      () => props.data,
      (newVal) => {
        if (newVal) {
          form.value = {
            name: newVal.name || "",
            code: newVal.code || "",
            description: newVal.description || "",
            parentRoles: newVal.parentRoles || []
          }
        }
      },
      { immediate: true, deep: true }
    )
    
    const validateForm = () =>
      new Promise((resolve, reject) => {
        formRef.value.validate().then((success) => {
          if (success) resolve(true)
          else reject()
        })
    })

    const validateAndSubmit = () => {
      validateForm()
        .then(() => {
          emit("submit", form.value)
        })
        .catch(() => console.error(i18n.t('message.requiredFieldsIncomplete')))
    }

      const getRolesForDropDown = async () => {    
        try {
          const query = {
            client_id: oid(clientId)
          }
          const items = await getItems({ collection: 'role', query } )
          rolesOptions.value = items?.map(({ name, _id }) => ({ title: name, value: _id.toString() })) || []
        } catch (error) {
          console.log(error)
        }
      }

    onMounted(() => {
      getRolesForDropDown()
    })

    return {
      form,
      formRef,
      validateAndSubmit,
      rolesOptions
    }
  },
}
</script>